'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _PropTypes = require('../utils/lib/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _CloseButton = require('./CloseButton');

var _CloseButton2 = _interopRequireDefault(_CloseButton);

var _DefaultShareButton = require('./DefaultShareButton');

var _DefaultShareButton2 = _interopRequireDefault(_DefaultShareButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var toArray = function toArray(thing) {
  return [].concat(thing);
};

var SharePanel = function (_Component) {
  _inherits(SharePanel, _Component);

  function SharePanel(props) {
    _classCallCheck(this, SharePanel);

    var _this = _possibleConstructorReturn(this, (SharePanel.__proto__ || Object.getPrototypeOf(SharePanel)).call(this, props));

    _this.closeSharePanel = _this.closeSharePanel.bind(_this);
    _this.handleFocusOut = _this.handleFocusOut.bind(_this);
    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(SharePanel, [{
    key: 'toggleSharePanel',
    value: function toggleSharePanel(e) {
      this.setState({ isOpen: !this.state.isOpen });
      e.stopPropagation();
      e.preventDefault();
    }
  }, {
    key: 'closeSharePanel',
    value: function closeSharePanel(ev) {
      if (this.state.isOpen && !this.sharePanel.contains(ev.target)) {
        this.setState({ isOpen: false });
      }
    }
  }, {
    key: 'handleFocusOut',
    value: function handleFocusOut(ev) {
      // when tabbing out of SharePanel, ev.relatedTarget is the element getting focus,
      // but when clicking inside SharePanel, ev.relatedTarget is null, which we need to check if the clicking
      // happened inside SharePanel.
      this.closeSharePanel({ target: ev.relatedTarget || ev.target });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.closeSharePanel);
      document.addEventListener('touchstart', this.closeSharePanel);
      document.addEventListener('focusout', this.handleFocusOut);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.closeSharePanel);
      document.removeEventListener('touchstart', this.closeSharePanel);
      document.removeEventListener('focusout', this.handleFocusOut);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          ctaText = _props.ctaText,
          headerText = _props.headerText,
          readMoreText = _props.readMoreText,
          ShareButton = _props.shareButtonComponent,
          onClickCallback = _props.onClickCallback;


      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)('ec-share-tools', className),
          ref: function ref(sharePanel) {
            _this2.sharePanel = sharePanel;
          }
        },
        _react2.default.createElement(ShareButton, {
          className: 'ec-share-tools__open-button',
          active: this.state.isOpen,
          onButtonClick: function onButtonClick(e) {
            if (onClickCallback) onClickCallback();
            _this2.toggleSharePanel(e);
          },
          ctaText: ctaText
        }),
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)({
              'ec-share-panel': true,
              'ec-share-panel--open': this.state.isOpen
            })
          },
          _react2.default.createElement(
            'div',
            { className: 'ec-share-panel__header' },
            _react2.default.createElement(
              'span',
              { className: 'ec-share-panel__header-text' },
              headerText
            ),
            _react2.default.createElement(_CloseButton2.default, { onClick: function onClick(e) {
                return _this2.toggleSharePanel(e);
              } })
          ),
          _react2.default.createElement(
            'div',
            { className: 'ec-share-panel__body' },
            _react2.default.createElement(
              'ul',
              { className: 'ec-share-panel__items' },
              toArray(children).map(function (item, i) {
                return _react2.default.createElement(
                  'li',
                  { key: i, className: 'ec-share-panel__item' },
                  item
                );
              }),
              _react2.default.createElement(
                'li',
                { className: 'ec-share-panel__item' },
                _react2.default.createElement(
                  'a',
                  {
                    className: 'ec-share-panel__read-more-link',
                    href: 'http://www.bbc.co.uk/faqs/questions/bbc_online/sharing'
                  },
                  readMoreText
                )
              )
            )
          )
        )
      );
    }
  }]);

  return SharePanel;
}(_react.Component);

SharePanel.defaultProps = {
  children: [],
  ctaText: 'Share',
  direction: 'up',
  headerText: 'Share this with',
  isOpen: false,
  readMoreText: 'Read more about sharing.',
  shareButtonComponent: _DefaultShareButton2.default
};

SharePanel.propTypes = {
  direction: _PropTypes2.default.string,
  children: _PropTypes2.default.node,
  className: _PropTypes2.default.string,
  ctaText: _PropTypes2.default.string,
  headerText: _PropTypes2.default.string,
  isOpen: _PropTypes2.default.bool,
  readMoreText: _PropTypes2.default.string,
  shareButtonComponent: _PropTypes2.default.func,
  onClickCallback: _PropTypes2.default.func
};

exports.default = SharePanel;